import { Accordion, AccordionDetails, AccordionSummary } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import * as React from 'react';
import DialogTitle from 'v2/components/Shared/DialogTitle';
import { useProductOffers } from 'v2/hooks/useProductOffers';

import { PricesList } from './PricesList';
import { useStyles } from './styles';

type LinksModalProps = {
  isOpen: boolean;
  planId: number;
  planTitle: string;
  closeModal: () => void;
};

function LinksModal({ isOpen, planId, planTitle, closeModal }: LinksModalProps) {
  const classes = useStyles();

  const offersQuery = useProductOffers(
    {
      productId: planId,
    },
    { enabled: !!planId }
  );

  return (
    <Dialog open={isOpen} maxWidth='md' fullWidth>
      <DialogTitle onClose={closeModal}>
        <Typography>
          <strong>Links deste plano</strong>
        </Typography>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        {offersQuery.data?.map((offer, index) => (
          <Accordion defaultExpanded={index === 0} key={offer.id}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography>{planTitle}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <PricesList offer={offer} />
            </AccordionDetails>
          </Accordion>
        ))}
      </DialogContent>
    </Dialog>
  );
}

export { LinksModal };
